import React from 'react'
import PropTypes from 'prop-types'
import ActionModal from './ActionModal'
import RequestContent from '../RequestContent'
import { useTransition } from 'react-spring'
import { Modal } from '@entrata/portals-common/lib/components'
import { X } from '@entrata/portals-common/lib/icons'
import {
  StyledModalDiv,
  StyledTitle,
  StyledWrapper,
  portalStyle,
  rootStyle,
} from './rp-modal'
import Media from 'react-media'

import styled from '@emotion/styled'

import { underlineFocus, FocusSpan } from '../focus-styles'

const StyledButton = styled('button')`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.gray.gray5};
  padding: 4px;
  transition: background 250ms ease-in-out;

  ${underlineFocus};
`

const StyledDiv = styled('div')`
  padding: 0 16px 16px 16px;
`

const StyledDivLargeBtn = styled('div')`
  padding: 0 16px 16px 16px;
  display: flex;
  justify-content: center;
`

const ModStyledWrapper = styled(StyledWrapper)`
  width: 90vw;
  max-width: 896px;
`

const ModStyledModalDiv = styled(StyledModalDiv)`
  height: 90vh;

  &.remove-pad {
    padding-bottom: 0;
  }

  @media screen and (min-width: 1024px) {
    height: 80vh;
  }
`

const ModStyledTitle = styled(StyledTitle)`
  align-items: center;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
`

const RequestContentModal = ({
  blurId,
  buttonLabel,
  children,
  hideCloseButton,
  onClose,
  requestContent,
  rootId,
  show,
  title,
  onButtonClick,
  modalOverModal,
  isTermsPage
}) => {
  const toggleRoot = action => {
    const rootElement = document.getElementById(rootId)
    const blurElement = document.getElementById(blurId)
    const blurReskinElement = document.getElementById('bg-overlay')
    if (!blurReskinElement?.classList?.contains('blur')) {
      rootElement && rootElement.classList[action](rootStyle)
      !modalOverModal && blurElement && blurElement.classList[action]('blur')
    }
  }

  React.useEffect(() => {
    toggleRoot(show ? 'add' : 'remove')

    if( !modalOverModal ){
      return function removeRootStyles() {
        toggleRoot('remove')
      }
    }
  }, [show])

  const transitions = useTransition(show, null, {
    from: { opacity: 0, transform: 'translateY(100px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-200px)' },
  })

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <Modal className={portalStyle} key={key} onClose={onClose}>
          {({ containerProps, titleId }) => (
            <ModStyledWrapper style={props}>
              <ModStyledModalDiv
                className={!hideCloseButton ? 'remove-pad' : ''}
                {...containerProps}
              >
                <ModStyledTitle id={titleId}>
                  {title || __('Title')}
                  <StyledButton onClick={onClose}>
                    <FocusSpan>
                      <X />
                    </FocusSpan>
                  </StyledButton>
                </ModStyledTitle>
                <RequestContent requestContent={requestContent} isTermsPage={isTermsPage}>
                  {children}
                </RequestContent>
                {!hideCloseButton && (
                  <StyledDivLargeBtn>
                    <Media query='(min-width: 1024px)'>
                      {largeScreen => (
                        <ActionModal.Button
                          size='large'
                          noMarginRight
                          onClick={() => {
                            onClose()
                            onButtonClick &&
                              typeof onButtonClick === 'function' &&
                              onButtonClick()
                          }}
                          slim={largeScreen}
                          style={{ marginTop: '16px' }}
                        >
                          {buttonLabel}
                        </ActionModal.Button>
                      )}
                    </Media>
                  </StyledDivLargeBtn>
                )}
              </ModStyledModalDiv>
            </ModStyledWrapper>
          )}
        </Modal>
      ),
  )
}

RequestContentModal.propTypes = {
  /** ID of the background to be blurred  */
  blurId: PropTypes.string,
  /** Custom text for close button */
  buttonLabel: PropTypes.string,
  /** You can directly pass some string content to show to the users */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  /** To toggle visibility of Close button */
  hideCloseButton: PropTypes.bool,
  /** onClose method, provided by the modal control */
  onClose: PropTypes.func.isRequired,
  /** An api call method (get method) to execute to fetch fresh content */
  requestContent: PropTypes.func,
  /** ID of the root element */
  rootId: PropTypes.string,
  /** A flas to show/hide modal. Provided by modal control */
  show: PropTypes.bool,
  /** Title of the modal  */
  title: PropTypes.string,
  onButtonClick: PropTypes.func,
}

RequestContentModal.defaultProps = {
  blurId: 'bg-img',
  buttonLabel: __('Close'),
  rootId: 'root',
  modalOverModal: false
}

export default RequestContentModal
